import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router';
import {passwordLogin, userInfo} from '@/api/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
  },
  getters: {
    userInfo: state => state.userInfo,
    token: state => state.token,
    // 增加一个判断：是否已经获取过用户信息（防止重复调用）
    hasUserInfo: state => !!state.userInfo
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = null
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
  },
  actions: {
    // 登录（只负责登录，不主动获取信息）
    async login({commit, dispatch}, loginForm) {
      const response = await passwordLogin(loginForm)
      if (response) {
        // 1. 设置 token
        const token = response.data.token.token
        commit('SET_TOKEN', token)

        // 记住密码
        if (loginForm.remember) {
          localStorage.setItem('remembered_user', JSON.stringify({
            phone: loginForm.phone,
            password: loginForm.password
          }))
        } else {
          localStorage.removeItem('remembered_user')
        }
      }

      // 登录成功后，手动获取一次用户信息
      await dispatch('getUserInfo')
      return response
    },

    // 获取用户信息（只会执行 1 次）
    async getUserInfo({commit}) {
      try {
        const res = await userInfo() // 👈 只调用 1 次
        commit('SET_USER_INFO', res.data)

        // 权限判断 + 跳转
        const authNode = res.data.auth_node
            ? res.data.auth_node.split(',').map(Number).filter(Boolean)
            : []

        let path = '/training' // 默认无权限

        // 权限判断
        if (authNode.length !== 0) {
          const has1 = authNode.includes(1)
          const has2 = authNode.includes(2)

          if (has1 && has2) {
            // 同时有 1 + 2 → 首页
            path = '/home'
          } else if (has1) {
            // 只有 1 → 首页
            path = '/home'
          } else if (has2) {
            // 只有 2 → 客户录入
            path = '/entry'
          }
        }

        // 最终跳转
        setTimeout(() => {
          router.replace(path)
        }, 0)

        return res.data
      } catch (error) {
        commit('CLEAR_AUTH')
        throw error
      }
    },

    // 登出
    async logout({commit}) {
      commit('CLEAR_AUTH')
      router.replace('/login')
    }
  },
  modules: {}
})
